import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "border-0 d-flex justify-content-between align-items-center mb-4" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex gap-2"
}
const _hoisted_4 = ["data-bs-target", "disabled"]
const _hoisted_5 = ["disabled"]


import TableBreadCrumbs from "./TableBreadCrumbs.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableTitle',
  props: {
    title: {},
    icon: {},
    showAction: { type: Boolean },
    modal: { default: "" },
    actionLabel: {},
    pageTitle: {},
    disabled: { type: Boolean }
  },
  emits: ["action"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const emitAction = () => {
  emit("action");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TableBreadCrumbs, { title: __props.pageTitle }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(__props.title), 1),
      (__props.showAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (__props.modal)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary btn-sm",
                  type: "button",
                  "data-bs-toggle": "modal",
                  "data-original-title": "test",
                  "data-bs-target": '#' + __props.modal,
                  disabled: __props.disabled
                }, [
                  _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(__props.actionLabel), 1)
                ], 8, _hoisted_4))
              : _createCommentVNode("", true),
            (!__props.modal)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-primary btn-sm",
                  onClick: emitAction,
                  disabled: __props.disabled
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(__props.actionLabel), 1)
                ], 8, _hoisted_5))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})